module.exports = __webpack_public_path__ + "img/code.83a11584.png";